var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-main background-image"},[_c('div',{staticClass:"auth-box"},[_c('router-view',{staticClass:"auth-body d-flex-c-jfs-ast-gap30"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }